<template>
  <!-- CurriculumTopicSlide-->
        <div @mousedown="onMouseDown" @mousemove="onMouseMove" @click="go_to($event)" class="row p-2 p-sm-3 align-items-center linklike linkedCard card-body" @mouseover="hover = true" @mouseleave="hover = false" :class="{ 'hover-card-asdf': hover }" >
        <!-- romman204
         <div @click="go_to()" class="row p-2 p-sm-3 align-items-center linklike w-100" @mouseover="hover = true" @mouseleave="hover = false" :class="{ 'hover-card': hover }" > 
        -->
            <div class="mb-0" :class="imageColClass">
              <div class="cardImageWrapper">
                <img :src="backgroundImage" class="img-fluid cardImage rounded-4" alt="flash card image">
              </div>
              <!-- <div class="rounded-3 cardImage" :style="{ backgroundImage: backgroundImage }"></div> -->
            </div>
            <div :class="[textColClass, 'text-start']">
              <h5 class="card-title fnt-18-xs fw-semibold">{{ displayName }}</h5>
              <small v-if="topic?.words_total > 0" class="text-muted">{{
                      topic.words_learned }}/{{ topic.words_total }} {{ t('curriculum.words') }}</small>
              <small v-else class="text-muted">
                {{ teaserName }}
              </small> 
              <div v-if="topic?.words_total > 0" class="progress mt-2" style="height: 8px;">
                <div class="progress-bar" role="progressbar" 
                  :style="{ width: (topic.words_learned / topic.words_total * 100) + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
              <div v-else class="progress mt-2" style="height: 8px;">
                <div class="progress-bar" role="progressbar"  style="width: 0%"  aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>
        </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const isDragging = ref(false)
const onMouseDown = () => {
  console.log('mousedown set dragging false')
  isDragging.value = false
}
const onMouseMove = () => {
  console.log('mousemove set dragging true')
  isDragging.value = true
}

const props = defineProps({
  topic: {
    type: Object,
    required: false
  },
  unit: {
    type: Object,
    required: false
  },
  category: {
    type: Object,
    required: false
  },
  to: {
    type: Object,
    required: false
  },
  imageCols: {
    type: Number,
    default: 2,
  }
})
const imageColClass = props.imageCols === 2 ? 'col-4 col-xl-3' : 'col-4 col-lg-2';
const textColClass = props.imageCols === 2 ? 'col-8 col-xl-9' : 'col-8 col-lg-10';

function go_to(event) {
  console.log('goto called on ', event)
  if (isDragging.value) {
    console.log('dragging, dont go to topic')

    event.preventDefault()
    event.stopPropagation()
    return
  }

  if (props.to) {
    router.push(props.to)
  } else if (props.topic) {
    router.push({ name: 'CurriculumTopicView', params: { topicID: props.topic.id } })
  }
}

const hover = ref(false)

// Computed property to determine the display name
const displayName = computed(() => {
  if (props.topic) {
    return t(`curriculum-topic.name.${props.topic.id}`)
  } else if (props.unit) {
    return t(`curriculum-unit.name.${props.unit.id}`)
  } else if (props.category) {
    return t(`curriculum-category.name.${props.category.id}`)
  } else {
    return t('curriculum.unknown') // Fallback translation key
  }
})

// Computed property to determine the background image
const backgroundImage = computed(() => {
  if (props.topic?.background_image) {
    return `${props.topic.background_image}`
  } else if (props.unit?.background_image) {
    return `${props.unit.background_image}`
  } else if (props.category?.background_image) {
    return `${props.category.background_image}`
  } else {
    return '' // No background image
  }
})

// Computed property to determine the teaser name
const teaserName = computed(() => {
  if (!props.topic?.words > 0) {
    var alternates =  [
      'curriculum.get-started',
      'curriculum.begin-now',
      'curriculum.start-learning',
      'curriculum.jump-in',
      'curriculum.try-this',
      'curriculum.dive-in'
    ]
    return t(alternates[Math.floor(Math.random() * alternates.length)])
  }
  else {
    return ''
  } 
})

</script>
<style lang="css" scoped>

h1,
h2 {
  font-weight: normal;
}
.cardImage{
  width: 100%;
  height: 100px;
  border: 1px solid #d8d8d8;
  object-fit: cover;
}
.cardImageWrapper{
  position: relative;
}
.cardImageWrapper::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    transition: .5s ease;
    border-radius:1rem;
}
.card-body:hover .cardImageWrapper::before {
    background: rgba(0, 0, 0, 0);
    transition: .5s ease;
}
.progress-bar{
  height: 8px;
    background-color: #3260a9;
}
@media(max-width:992px){
  .cardImage{
    height:85px;
  }
  .fnt-18-xs{
    font-size:18px;
  }
}
/* .progress-bar {
    background: #aaf;
}
.carousel__slide {
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.carousel-card,
.card-body {
  height: calc(115px * 0.94);
  width: calc(200px * 0.94);
  background-size: cover;
  background-position: center;
  position: relative;
} */

/* Media query for larger screens */
/* @media (min-width: 375) {
  .carousel-card,
  .card-body {
    height: 115px;
    width: 200px;
  }
}

h5.card-title {
  font-size: 100%;
  color: white !important;
  padding: 5px;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  width: 100%;
  text-align: center;
  -webkit-text-stroke: 3px black;
  paint-order: stroke fill;
}

.hover-card {
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ddf;
} */
</style>
